export default "__VITE_PUBLIC_ASSET__dafb7472__"